import { SecurityHelper } from 'sarsaparilla';
import * as endpoints from './endpoints';
import { apiHelpers } from '../../../ui-lottery/src/api/helpers';

const { get, getWithAuth, postWithAuth, putWithAuth } = apiHelpers(SecurityHelper);

// Reservations
export const getReservation = (resId) => getWithAuth(endpoints.reservationEndpoint(resId));
export const createReservation = (res) => postWithAuth(endpoints.reservationsEndpoint(), res);
export const updateReservation = (res) => putWithAuth(endpoints.reservationEndpoint(res.id), res);

// Facilities
export const getFacilities = () => getWithAuth(endpoints.facilitiesEndpoint());

// Pass Types
export const getPassTypesByFacility = (facilityId) => get(endpoints.passTypesByFacilityEndpoint(facilityId));
export const getPassType = (passTypeId) => get(endpoints.passTypeEndpoint(passTypeId));
